export const circleX = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="var(--searchbar-border-color)" />
    <path d="M8 16L16 8" stroke="var(--secondary-icon-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 8L16 16" stroke="var(--secondary-icon-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
